module.exports = __webpack_public_path__ + "static/media/Alpha-iQ-tm-RA-6700-iQ.93b1ce72.png";